import { Injectable } from '@angular/core';
import { ICategory } from './category.service';
import { IGroup } from './group.service';
import { ApiService } from './api.service';
import { environment } from '../../../environments/environment';
import { IEvent } from './event.service';

@Injectable({
  providedIn: 'root'
})
export class ArticleService {


  constructor(private apiService: ApiService) {
  }

  createArticle(article: IArticle) {
    return this.apiService.post(`${environment.serverUrl}/v1/articles`, article);
  }

  getArticles() {
    return this.apiService.get(`${environment.serverUrl}/v1/admin/articles`);
  }

  getPublicArticles() {
    return this.apiService.get(`${environment.serverUrl}/v1/articles`);
  }

  getPublicArticle(id) {
    return this.apiService.get(`${environment.serverUrl}/v1/articles/${id}`);
  }

  getArticle(id) {
    return this.apiService.get(`${environment.serverUrl}/v1/articles/${id}`);
  }

  deleteArticle(articleId: string) {
    return this.apiService.delete(`${environment.serverUrl}/v1/articles/${articleId}`);
  }

  updateArticle(id, article: IArticle) {
    return this.apiService.put(`${environment.serverUrl}/v1/articles/${id}`, article);
  }

  getHomepageInformation() {
    return this.apiService.get(`${environment.serverUrl}/v1/homepage/grouped`);
  }

  getSearchResults(term) {
    return this.apiService.get(`${environment.serverUrl}/v1/search/${term}`);
  }

  getSearchCategoryResults(categoryId) {
    return this.apiService.get(`${environment.serverUrl}/v1/search/category/${categoryId}`);
  }

  submitHelpForm(data, department) {
    return this.apiService.post(`${environment.serverUrl}/v1/forms/submit`, {
      department,
      fields: data
    });
  }

  submitApplication(eventId, data) {
    return this.apiService.post(`${environment.serverUrl}/v1/events/${eventId}/apply`, {
      fields: data
    });
  }

}


export interface IArticle {

  _id?: string;
  title?: string;
  text?: string;
  status?: ARTICLE_STATUS;
  videoUrl?: string;
  tags?: Array<string>;
  attachments?: Array<File>;
  categories?: Array<ICategory>;
  groups?: Array<IGroup>;
  dateCreated?: Date;
  publishDate?: Date;
  image?: IFile;
}

export interface IFile {
  _id?: string | number;
  url?: string;
  thumbUrl?: string;
  type?: FileType;
  uploadClientId?: string;
  originalFileName?: string;
  timeCreated?: Date;
  fileStatus?: string;
  totalFiles?: number;
  processedFiles?: number;
  size?: number;
}

export enum FileType {
  IMAGE = 'IMAGE',
  GIF = 'GIF'
}


export enum ARTICLE_STATUS {
  PUBLISHED = 'PUBLISHED',
  DRAFT = 'DRAFT',
  DELETED = 'DELETED'
}
